module.exports = __webpack_public_path__ + "static/img/3.e19175a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/7/zh/3.png
// module id = LJAv
// module chunks = 0